import { useCallback } from 'react'
import { useHistory, useParams } from 'react-router'

import { useQueryParams } from '../../../core/router'

type ProductPageUrlParams = {
  productId: string
}

export const useProductPageUrlParams = () => {
  const history = useHistory()
  const queryParams = useQueryParams()
  const selectedSkuId = queryParams.get('skuId') ?? ''
  const params = useParams<ProductPageUrlParams>()
  const { productId } = params

  const setSelectedSkuId = useCallback(
    (newSelectedSkuId: string) => {
      queryParams.set('skuId', newSelectedSkuId)

      history.replace({
        search: `?${queryParams.toString()}`,
      })
    },
    [history, queryParams]
  )

  return {
    productId,
    selectedSkuId,
    setSelectedSkuId,
  } as const
}
